<template>
  <div>
    <h2 class="col-lg-12 text-center mb-3">Ver operação</h2>
    <div>
      <CCol sm="12">
        <CCard>
          <CCardBody class="d-flex flex-column">
            <!-- Date -->
            <label class="font-weight-bold">Data</label>
            <p>{{date}}</p>
            <!-- Tasks -->
            <label class="font-weight-bold">Tarefas</label>
            <table class="table table-striped">
              <tbody>
                <tr v-for="task in tasks" :key="task.id">
                  <td>{{task.name}}</td>
                  <td v-if="task.tools">{{getReadableTools(task.tools)}}</td>
                </tr>
              </tbody>
            </table>
            <!-- Places -->
            <label class="font-weight-bold">Locais</label>
            <table class="table table-striped">
              <tbody>
                <tr v-for="(place, index) in places" :key="index">
                  <td>{{place}}</td>
                </tr>
              </tbody>
            </table>
            <!-- People -->
            <label class="font-weight-bold">Recursos humanos</label>
            <table class="table table-striped">
              <tbody>
                <tr v-for="person in people" :key="person.id">
                  <td>{{person.name}}</td>
                  <td>{{person.hours}} horas, {{person.cost.toFixed(2)}}€</td>
                </tr>
              </tbody>
            </table>
            <!-- Notes -->
            <label class="font-weight-bold">Notas</label>
            <p>{{notes}}</p>
          </CCardBody>
        </CCard>
      </CCol>
    </div>
  </div>
</template>
 
<script>
import { mapState, mapActions } from 'vuex'
import router from '@/router';
import { UTILS_HELPER } from "@/helpers/utils.js";

export default {
  computed:{
    ...mapState('operations', ['operationOutput']),
    operationDetails: function()
    {
      return this.operationOutput && this.operationOutput.obj ? this.operationOutput.obj.operationDetails : null;
    },
    date: function()
    {
      return this.operationDetails ? UTILS_HELPER.formatDate(this.operationDetails.date) : null;
    },
    tasks: function()
    {
      return this.operationDetails ? this.operationDetails.tasks : null;
    },
    places: function()
    {
      return this.operationDetails ? this.operationDetails.places : null;
    },
    people: function()
    {
      return this.operationDetails ? this.operationDetails.employees : null;
    },
    notes: function()
    {
      return this.operationDetails ? this.operationDetails.notes : null;
    }
  },
  methods: {
      ...mapActions('operations', ['getOperation']),
      getReadableTools(tools)
      {
        var readableTools = [];
        tools.forEach(tool => {
          var readableTool = tool.name;

          if(tool.attributes && tool.attributes.length)
          {
            var attributes = tool.attributes.map(attribute=>
            {
              var value = attribute.value;

              if(value === 'True')
              {
                value = "Sim";
              }
              else if(value == 'False')
              {
                value = "Não";
              }

              return `${attribute.name}: ${value}`;
            });
            readableTool = `${readableTool} (${attributes.join(", ")})`;
          }

          readableTools.push(readableTool);
        });

        return readableTools.join(", ");
      }
  },
  mounted: function()
  {
    if(!this.$route.params.id)
    {
      router.push({ path: '/operacoes/lista' });
    }
    else
    {
      this.getOperation(this.$route.params.id);
    }
  }
}

</script> 
 
<style scoped>
td:nth-child(1)
{
  text-align: start;
}

td:nth-child(2)
{
  text-align: right;
}
</style> 